export const steps = [
    {
        selector: '.leaderboard-step',
        content: 'Informs the user that they can view the leaderboard, likely showing top performers or rankings within the platform.',
    },
    {
        selector: '.notification-step',
        content: "Explains where users can access their notifications, probably for updates, messages, or alerts within the system.",
    },
    {
        selector: '.addexternal-step',
        content: 'Guides users to a feature where they can add external training sessions or records, possibly from outside the platform.',
    },
    {
        selector: '.externallist-step',
        content: 'Shows users how to view a list of their external training records.',
    },
    {
        selector: '.message-step',
        content: 'Indicates where users can check their messages, likely including communications between admin ,learner and instructor.',
    },
    {
        selector: '.certificate-step',
        content: ' Points to a section where users can view certificates they have earned, indicating achievements or course completions.',
    },
    {
        selector: '.learning-step',
        content: ' Guides users to their learning modules, possibly courses or educational content available on the platform.',
    },
    {
        selector: '.group-step',
        content: 'Shows users where they can access the list of groups, potentially for collaboration or community interaction.',
    },
    {
        selector: '.training-step',
        content: ' Directs users to a list of available or completed training sessions.',
    },
    {
        selector: '.bookmark-step',
        content: 'Informs users where they can view their bookmarked items, such as saved courses or resources.',
    },
    {
        selector: '.time-step',
        content: 'Displays information on how much time the user has spent on the platform or specific activities.',
    },
    {
        selector: '.learninggraph-step',
        content: `Shows a visual representation of the user's progress, such as completed modules or courses. `,
    },
    {
        selector: '.badge-step',
        content: 'Guides users to a section where they can view badges earned, which could represent achievements or milestones.',
    },
    {
        selector: '.calendar-step',
        content: 'Points to a calendar feature where users can see upcoming or past training events, likely helping with scheduling and planning.',
    },
]